import { InputAdornment, TextField } from "@mui/material";
import { Controller, useFormContext } from "react-hook-form";
import { FormattedMessage } from "react-intl";

export const TextInput = ({
  name,
  label,
  rules,
  helper = {},
  disabled = false,
  helperText,
  suffix,
  sx = {},
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field, fieldState: { error } }) => {
        return (
          <TextField
            {...field}
            disabled={disabled}
            onChange={(event) => {
              field.onChange(!!event.target.value ? event.target.value : null);
            }}
            fullWidth
            id={name}
            label={label}
            required={rules?.required ?? false}
            error={error !== undefined}
            value={field.value?.toString() ?? ""}
            helperText={
              error ? (
                helper?.[name]?.[error.type] ? (
                  helper?.[name]?.[error.type]
                ) : (
                  <FormattedMessage
                    id={`common.${error.type}`}
                    values={{ field: label, length: rules?.[error?.type] }}
                  />
                )
              ) : (
                helperText ?? ""
              )
            }
            InputProps={{
              endAdornment: suffix ? (
                <InputAdornment position="end">{suffix}</InputAdornment>
              ) : null,
            }}
            sx={sx}
          />
        );
      }}
    />
  );
};
